import { Type } from 'class-transformer';
import { Model } from './model';

export enum LedgerAccountClassification {
  ASSET = 'asset',
  EQUITY = 'equity',
  EXPENSE = 'expense',
  LIABILITY = 'liability',
  REVENUE = 'revenue',
  OTHER = 'other',
}

export class LedgerAccount extends Model {
  id: string;

  classification: LedgerAccountClassification;

  currency: string;

  current_balance: number;

  description: string | null;

  is_active: boolean;

  is_direct_posting_enabled: boolean;

  name: string;

  number: string | null;

  remote_id: string | null;

  remote_parent_id: string | null;

  subtype: string | null;

  type: string;

  parent_account_id: string | null;

  @Type(() => LedgerAccount)
  parent_account: LedgerAccount | null;

  @Type(() => LedgerAccount)
  sub_accounts: LedgerAccount[];
}
